module.exports = __webpack_public_path__ + "media/pdf/Bonitätsmanager-Webbank+-e697957a9bd6de0b970e47095675af2c.pdf";